import React, { lazy } from 'react';
import { Card } from './ui/Card';
import { CheckCircle2, Baby, Users, TrendingUp, Gift } from 'lucide-react';
export function ProductBreakdown() {
  return <section className="py-20 bg-gray-50" id="que-incluye" data-id="element-153">
      <div className="container mx-auto px-4" data-id="element-154">
        <div className="text-center mb-16" data-id="element-155">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-4" data-id="element-156">
            ¿Qué Incluye el <span className="text-pink-600" data-id="element-157">MegaPack</span>?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-2" data-id="element-158">
            Todo lo que necesitás, dividido por niveles y edades.
          </p>
          <p className="text-base text-pink-600 font-semibold" data-id="element-159">
            📚 Tomos en formato digital PDF
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-160">
          {/* Nivel Inicial */}
          <Card className="flex flex-col h-full hover:shadow-2xl transition-shadow duration-300 border-t-4 border-t-green-500" data-id="element-161">
            <div className="p-8 flex-1 flex flex-col" data-id="element-162">
              <div className="w-full h-48 mb-4 mx-auto overflow-hidden rounded-lg" data-id="element-163">
                <img src="https://cdn.magicpatterns.com/uploads/wzVmoyUET89ZbDhRdA9Q65/heylloyd-image-1771891544584.png" alt="Nivel Inicial - Baby Dance" className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-164" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-165">
                Nivel Inicial
              </h3>
              <p className="text-center text-pink-600 font-semibold mb-4" data-id="element-166">
                (3 a 5 años)
              </p>
              <p className="text-gray-600 mb-6 text-center" data-id="element-167">
                Baby Dance y Pre-Danza
              </p>
              <ul className="space-y-3 flex-1" data-id="element-168">
                <li className="flex items-start gap-3" data-id="element-169">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-170" />
                  <span className="text-gray-700" data-id="element-171">
                    15 Cuentos Motores listos para dar
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-172">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-173" />
                  <span className="text-gray-700" data-id="element-174">
                    Circuitos psicomotrices con elementos
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-175">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-176" />
                  <span className="text-gray-700" data-id="element-177">
                    Dinámicas de grupo y ritmo
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-178">
                  <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-179" />
                  <span className="text-gray-700" data-id="element-180">
                    Evaluaciones lúdicas por edad
                  </span>
                </li>
              </ul>
            </div>
          </Card>

          {/* Nivel Primario */}
          <Card className="flex flex-col h-full hover:shadow-2xl transition-shadow duration-300 border-t-4 border-t-blue-600 transform md:-translate-y-4" data-id="element-181">
            <div className="p-8 flex-1 flex flex-col bg-white" data-id="element-182">
              <div className="w-full h-48 mb-4 mx-auto overflow-hidden rounded-lg" data-id="element-183">
                <img src="https://cdn.magicpatterns.com/uploads/juRvyQKKDjZGfUkJrJsbuH/heylloyd-image-1771891896686.png" alt="Nivel Primario - Técnica e Intermedio" className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-184" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-185">
                Nivel Primario
              </h3>
              <p className="text-center text-pink-600 font-semibold mb-4" data-id="element-186">
                (6 a 12 años)
              </p>
              <p className="text-gray-600 mb-6 text-center" data-id="element-187">
                Técnica e Intermedio
              </p>
              <ul className="space-y-3 flex-1" data-id="element-188">
                <li className="flex items-start gap-3" data-id="element-189">
                  <CheckCircle2 className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-190" />
                  <span className="text-gray-700" data-id="element-191">
                    Planificaciones semanales detalladas
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-192">
                  <CheckCircle2 className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-193" />
                  <span className="text-gray-700" data-id="element-194">
                    20 variaciones de diagonales y saltos
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-195">
                  <CheckCircle2 className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-196" />
                  <span className="text-gray-700" data-id="element-197">
                    Floorwork y técnica progresiva
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-198">
                  <CheckCircle2 className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-199" />
                  <span className="text-gray-700" data-id="element-200">
                    Proyectos coreográficos por trimestre
                  </span>
                </li>
              </ul>
            </div>
          </Card>

          {/* Nivel Avanzado */}
          <Card className="flex flex-col h-full hover:shadow-2xl transition-shadow duration-300 border-t-4 border-t-red-600" data-id="element-201">
            <div className="p-8 flex-1 flex flex-col" data-id="element-202">
              <div className="w-full h-48 mb-4 mx-auto overflow-hidden rounded-lg" data-id="element-203">
                <img src="https://cdn.magicpatterns.com/uploads/b3cwfLw6B8QADN8FjgWkBa/heylloyd-image-1771892106414.png" alt="Nivel Avanzado - Performance y Maestría" className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-204" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-205">
                Nivel Avanzado
              </h3>
              <p className="text-center text-pink-600 font-semibold mb-4" data-id="element-206">
                (13 a 18+ años)
              </p>
              <p className="text-gray-600 mb-6 text-center" data-id="element-207">
                Performance y Maestría
              </p>
              <ul className="space-y-3 flex-1" data-id="element-208">
                <li className="flex items-start gap-3" data-id="element-209">
                  <CheckCircle2 className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-210" />
                  <span className="text-gray-700" data-id="element-211">
                    Entrenamiento físico para bailarines
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-212">
                  <CheckCircle2 className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-213" />
                  <span className="text-gray-700" data-id="element-214">
                    Composición coreográfica avanzada
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-215">
                  <CheckCircle2 className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-216" />
                  <span className="text-gray-700" data-id="element-217">
                    Laboratorio de improvisación
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-218">
                  <CheckCircle2 className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-219" />
                  <span className="text-gray-700" data-id="element-220">
                    Anatomía aplicada y prevención
                  </span>
                </li>
              </ul>
            </div>
          </Card>

          {/* Bonos Exclusivos */}
          <Card className="flex flex-col h-full hover:shadow-2xl transition-shadow duration-300 border-t-4 border-t-pink-600" data-id="element-221">
            <div className="p-8 flex-1 flex flex-col" data-id="element-222">
              <div className="w-full h-48 mb-4 mx-auto overflow-hidden rounded-lg" data-id="element-223">
                <img src="https://cdn.magicpatterns.com/uploads/fKtXvp4iaKe9YhTmEyHrw7/heylloyd-image-1771892217538.png" alt="Bonos Exclusivos" className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-224" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-225">
                Bonos Exclusivos
              </h3>
              <p className="text-center text-pink-600 font-semibold mb-4" data-id="element-226">
                Recursos extra incluidos gratis
              </p>
              <ul className="space-y-3 flex-1" data-id="element-227">
                <li className="flex items-start gap-3" data-id="element-228">
                  <CheckCircle2 className="w-5 h-5 text-pink-600 flex-shrink-0 mt-0.5" data-id="element-229" />
                  <span className="text-gray-700" data-id="element-230">
                    Kit Muestras Sin Pánico (festival)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-231">
                  <CheckCircle2 className="w-5 h-5 text-pink-600 flex-shrink-0 mt-0.5" data-id="element-232" />
                  <span className="text-gray-700" data-id="element-233">
                    Generador de Aulas Llenas (marketing)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-234">
                  <CheckCircle2 className="w-5 h-5 text-pink-600 flex-shrink-0 mt-0.5" data-id="element-235" />
                  <span className="text-gray-700" data-id="element-236">
                    Biblioteca Musical BPM curada
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-237">
                  <CheckCircle2 className="w-5 h-5 text-pink-600 flex-shrink-0 mt-0.5" data-id="element-238" />
                  <span className="text-gray-700" data-id="element-239">
                    Planillas de asistencia y evaluación
                  </span>
                </li>
              </ul>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}